import * as types from '../actions/types';
import { actionTypes } from './reducerTypes';
const removeALLwindow = () => {
  return {
    showSignUpWindow: false,
    showUpgradeWindow: false,
    showLoginWindow: false,
    showLoginWindowWithDomain: false,
    showVerificationCodeWindow: false,
  };
};
let initialState = {
  pageLoading: false,
  showErrorPage: true,
  email: '',
  robotPage: false,
  previousAction: '',
  searchedDomain: '',
  linkedInCode: null,
  showPrivacyPolicy: false,
  showSellTerms: false,
  showSellPrivacy: false,
  showPaymentPopup: false,
  locationNotSupport: false,
  passwordAlertBox: false,
  showRemodelAlert: false,
  showPromoAlert: false,
  badLeadAlert: false,
  paymentFailedAlert: false,
  updateProfileWindow: false,
  googleProfile: {},
  localCountryStr: 'US',
  ...removeALLwindow(),
};

const mainReducer = (state = initialState, action: actionTypes) => {
  switch (action.type) {
    case types.LOCAL_COUNTRY_DETAIL:
      return {
        ...state,
        localCountryStr: (action.payload && action.payload.country_code) || 'US',
      };
    case types.PAYMENT_POPUP:
      return {
        ...state,
        showPaymentPopup: action.payload,
      };
    case types.LOCATION_NOT_SUPPORT:
      return {
        ...state,

        locationNotSupport: action.payload,
      };
    case types.PASSWORD_SENT_ALERT:
      return {
        ...state,
        passwordAlertBox: action.payload,
      };
    case types.SHOW_REMODEL_ALERT:
      return {
        ...state,
        showRemodelAlert: action.payload,
      };
    case types.SHOW_PROMO_CODE:
      return {
        ...state,
        showPromoAlert: action.payload,
      };
    case types.SHOW_BAD_LEAD:
      return {
        ...state,
        badLeadAlert: action.payload,
      };
    case types.SHOW_PAYMENT_FAILED:
      return {
        ...state,
        paymentFailedAlert: action.payload,
      };

    case types.EMAIL_VERIFICATION:
      return {
        ...state,
        ...removeALLwindow(),
        showVerificationCodeWindow: action.payload,
      };
    case types.SET_LINKEDIN_CODE:
      return {
        ...state,
        linkedInCode: action.payload,
      };
    case types.SEARCHED_DOMAIN:
      return {
        ...state,
        searchedDomain: action.payload,
      };
    case types.ROBOT_PAGE:
      return {
        ...state,
        robotPage: action.payload,
      };
    case types.PREVIOUS_ACTION:
      return {
        ...state,
        previousAction: action.payload,
      };
    case types.PAGE_LOADER:
      return {
        ...state,
        pageLoading: action.payload,
      };

    case types.SIGN_UP_WITH_DOMAIN:
      return {
        ...state,
        showLoginWindowWithDomain: action.payload,
      };
    case types.GOOGLE_PROFILE:
      return {
        ...state,
        googleProfile: action.payload,
      };

    case types.SHOW_LOGIN_WINDOW:
      return {
        ...state,
        showLoginWindow: action.payload,
        showLoginWindowWithDomain: action.payload ? state.showLoginWindowWithDomain : false,
        showUpgradeWindow: false,
        showSignUpWindow: action.payload ? state.showSignUpWindow : false,
      };
    case types.SHOW_UPGRADE_WINDOW:
      return {
        ...state,
        showLoginWindow: false,
        showUpgradeWindow: action.payload,
      };
    case types.SHOW_SIGNUP_WINDOW:
      return {
        ...state,
        showSignUpWindow: action.payload,
      };
    case types.TERMS_AND_SERVICE:
      return {
        ...state,
        showPrivacyPolicy: action.payload,
      };
    case types.SELL_TERMS_AND_SERVICE:
      return {
        ...state,
        showSellTerms: action.payload,
      };
    case types.SELL_PRIVACY_POLICY:
      return {
        ...state,
        showSellPrivacy: action.payload,
      };
    default:
      return state;
  }
};

export default mainReducer;
